<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 12L5 9" stroke="var(--bg-color)" stroke-width="2" />
    <path d="M11 4L5 7" stroke="var(--bg-color)" stroke-width="2" />
    <circle cx="3" cy="8" r="2" stroke="var(--bg-color)" stroke-width="2" />
    <circle cx="13" cy="3" r="2" stroke="var(--bg-color)" stroke-width="2" />
    <circle cx="13" cy="13" r="2" stroke="var(--bg-color)" stroke-width="2" />
</svg>

